<template>
    <path
        d="M13.6 2.4L9.75 13.6L7.35 8.65L2.4 6.4Z"
    />
</template>
